import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Select, List } from 'antd'

import AddEditParameter from './AddEditParameter'

@inject((store: any) => {
    const { popupStore, parametersStore, rightParamSetStore, paramGroupsStore } = store
    return { popupStore, parametersStore, rightParamSetStore, paramGroupsStore }
})
@observer
export default class ParametersPopup extends Component<any, any> {
    state: any = {
        errors: {}
    }
    updateParametersList = async () => {
        const { paramGroupsStore, parametersStore, popupStore, rightParamSetStore } = this.props
        await parametersStore.getParametersList({ right_param_set_id: popupStore.info.id })
        await paramGroupsStore.getList()
        await parametersStore.resetFilters()
        await rightParamSetStore.getList()
    }
    closePopup = () => {
        this.props.parametersStore.resetParameters()
        this.props.popupStore.togglePopup(false)
    }
    render() {
        const { popupStore, parametersStore, paramGroupsStore } = this.props
        const { id, name } = popupStore.info
        const title =
            parametersStore.filteredList.length > 0
                ? `נמצאו ${parametersStore.filteredList.length} פרמטרים`
                : 'לא נמצאו פרמטרים'
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
            </div>
        )
        return (
            <Modal
                title={`עריכת פרמטרים בטבלה ${name} (מזהה: ${id})`}
                visible={popupStore.popupType === 'editParameters'}
                cancelText="ביטול"
                width={600}
                bodyStyle={{ padding: '0.5rem 1.5rem' }}
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                <label>
                    <strong style={{ fontSize: '1.1rem' }}>{title}</strong>
                </label>
                <div
                    style={{
                        display: 'flex',
                        width: '100%',
                        flexDirection: 'column',
                        padding: '0.5rem 0rem 0.8rem'
                    }}
                >
                    <Input.Search
                        name="filterParameters"
                        placeholder="סינון על פי שם פרמטר"
                        value={parametersStore.filters['name']}
                        onChange={e => parametersStore.addFilter('name', e.target.value)}
                    />
                    <Select
                        style={{ width: '100%' }}
                        placeholder="סינון על פי קבוצת פרמטרים"
                        value={parametersStore.filters['param_group_id']}
                        onChange={e => parametersStore.addFilter('param_group_id', e)}
                    >
                        <Select.Option value={null} key="ALL">
                            כל הקבוצות
                        </Select.Option>
                        <Select.Option value="EMPTY" key="EMPTY">
                            ללא שיוך לקבוצה
                        </Select.Option>
                        {paramGroupsStore.list.map(paramGroup => (
                            <Select.Option value={paramGroup.id} key={paramGroup.id}>
                                {paramGroup.name}
                            </Select.Option>
                        ))}
                    </Select>
                    <AddEditParameter
                        right_param_set_id={popupStore.info.id}
                        rightUpdated={() => this.updateParametersList()}
                    />
                    <List
                        className="center-table"
                        style={{ width: '100%' }}
                        rowKey="id"
                        dataSource={parametersStore.filteredList}
                        pagination={{
                            hideOnSinglePage: true,
                            pageSize: 8
                        }}
                        renderItem={item => (
                            <AddEditParameter {...item} rightUpdated={() => this.updateParametersList()} />
                        )}
                    />
                </div>
            </Modal>
        )
    }
}
